export default __webpack_public_path__ + "static/calendar-mock-377ed34b108488d23caeb330a8d94053.svg";